export const basic = [
  {
    key: 'integer_weighted_run_created_per_35_at_bat',
    label: '64 Rank',
    sortable: true,
    class: '!text-left rankings-col',
  },
  { key: 'year', label: 'Year', sortable: true, class: '!text-left' },
  { key: 'team_name', label: 'School', sortable: true, class: '!text-left' },
  { key: 'conference_abbreviation', label: 'Conference', sortable: true, class: '!text-left' },
  { key: 'on_base_plus_slugging', label: 'OPS', sortable: true, direction: 'desc' },
  { key: 'weighted_on_base_average', label: 'wOBA', sortable: true, direction: 'desc' },
  { key: 'isolated_power', label: 'ISO', sortable: true, direction: 'desc' },
  { key: 'weighted_runs_created', label: 'wRC', sortable: true, direction: 'desc' },
  { key: 'weighted_runs_above_average', label: 'wRAA', sortable: true, direction: 'desc' },
  { key: 'runs_plate_appearance', label: 'R/PA', sortable: true, direction: 'desc' },
  { key: 'runs_created_ab', label: 'RC/AB', sortable: true, direction: 'desc' },
  { key: 'weighted_run_created_efficiency', label: 'wRCE', sortable: true, direction: 'desc' },
  {
    key: 'rank_weighted_run_created_per_35_at_bat',
    label: 'Rank',
    sortable: true,
    direction: 'desc',
  },
];
